"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderService = exports.m = void 0;
const tslib_1 = require("tslib");
const redraw_1 = tslib_1.__importDefault(require("mithril/api/redraw"));
const hyperscript_1 = tslib_1.__importDefault(require("mithril/hyperscript"));
const mobx_1 = require("mobx");
const index_1 = require("./index");
const log_service_1 = require("./log.service");
const trigger_1 = require("./util/trigger");
exports.m = hyperscript_1.default;
class RenderService {
    constructor() {
        this.__priority = 10;
    }
    init() {
        this.boundRedraw = (0, redraw_1.default)(index_1.Services.Window.window);
    }
    render(el, nodes) {
        this.boundRedraw.render(el, nodes);
    }
    mount(el, component, name) {
        if (component == null) {
            if (el.$mobxDispose) {
                el.$mobxDispose();
                el.$mobxDispose = null;
            }
            return;
        }
        const trigger = new trigger_1.IkeTrigger(name);
        let lastRedraw = Date.now();
        const boundRedraw = this.boundRedraw;
        function renderFunction() {
            try {
                const startTime = Date.now();
                // Force watching the trigger,
                // This will allow us to manually trigger redraws when needed.
                trigger.observe();
                const sinceLastRedraw = startTime - lastRedraw;
                // VNodes need to be computed every time otherwise everything inside the component
                // will become un-observed on every redraw.
                const nodes = component.view();
                if (sinceLastRedraw < 16 || trigger.isTriggering) {
                    trigger.trigger();
                    return;
                }
                // Mithril redraw
                boundRedraw.render(el, nodes);
                lastRedraw = Date.now();
                const duration = lastRedraw - startTime;
                if (duration > 100) {
                    index_1.Services.Log.Logger.warn({ component: name, duration }, 'Long redraw');
                    index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Performance, 'draw:slow', name, duration);
                }
            }
            catch (error) {
                log_service_1.Logger.error(`Failed to render component ${name}`);
                throw error;
            }
        }
        el.$mobxDispose = (0, mobx_1.autorun)(renderFunction, { name: `reaction:${name}` });
    }
}
exports.RenderService = RenderService;
//# sourceMappingURL=render.service.js.map